import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthenticationResult } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styles: [`:host { display: block; height: 100%; }`],
})
export class App implements OnInit {
  constructor(private authService: MsalService) {}

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe((result: AuthenticationResult | null) => {
      if (result?.account) {
        this.authService.instance.setActiveAccount(result.account);
      } else {
        const account = this.authService.instance.getActiveAccount() ?? this.authService.instance.getAllAccounts()[0];
        if (account) {
          this.authService.instance.setActiveAccount(account);
        }
      }

      // Ensure auth callback query/hash fragments are removed after redirect processing.
      if (window.location.search || window.location.hash) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    });
  }
}
